'use client';

import Image from 'next/image';
import React, { useEffect, useRef, useState, CSSProperties } from 'react';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { ProductDetailProps } from '@/types/dataTypes';

function SamplePrevArrow(props: { className: any; style: any; onClick: any }) {
	const { className, style, onClick } = props;
	return (
		<div
			className={className}
			style={{
				...style,
				display: 'block',
				left: -40,
				top: 32,
				width: 35,
				height: 64,
			}}
			onClick={onClick}
		>
			<Image
				className=""
				alt="news_prev"
				src="/c_21.png"
				width={35}
				height={62}
				quality={100}
				style={{
					width: '100%',
					height: '100%',
					position: 'absolute',
					top: 0,
					left: 0,
				}}
			></Image>
		</div>
	);
}

function SampleNextArrow(props: { className: any; style: any; onClick: any }) {
	const { className, style, onClick } = props;
	return (
		<div
			className={className}
			style={{
				...style,
				display: 'block',
				right: -39,
				top: 32,
				width: 35,
				height: 64,
			}}
			onClick={onClick}
		>
			<Image
				className=""
				alt="news_prev"
				src="/c_23.png"
				width={35}
				height={62}
				quality={100}
				style={{
					width: '100%',
					height: '100%',
					position: 'absolute',
					top: 0,
					left: 0,
				}}
			></Image>
		</div>
	);
}
const ProductDetailCarousel = ({ productDetailData }: ProductDetailProps) => {
	const [nav1, setNav1] = useState(null);
	const [nav2, setNav2] = useState(null);
	const [selectedIndex, setSelectedIndex] = useState(0);
	const slider1 = useRef(null);
	const slider2 = useRef(null);
	const [mov, setMov] = useState({
		movementX: 0,
		movementY: 0,
	});
	const [isImageDetail, setIsImageDetail] = useState(false);

	useEffect(() => {
		setNav1(slider1.current);
		setNav2(slider2.current);
	}, []);

	let imgUrlAry;
	if (productDetailData.imgurls && productDetailData.imgurls?.length > 0) {
		imgUrlAry = JSON.parse(productDetailData.imgurls);
	}

	if (!Array.isArray(imgUrlAry)) return null;

	const topSliderSettings = {
		asNavFor: nav2,
		ref: (slider: any) => (slider1.current = slider),
		afterChange: function (index: any) {
			setSelectedIndex(index);
		},
		infinite: imgUrlAry.length > 0,
	};

	const bottomSliderSettings = {
		asNavFor: nav1,
		ref: (slider: any) => (slider2.current = slider),
		infinite: imgUrlAry.length > 5,
		slidesToShow: 6,
		swipeToSlide: true,
		focusOnSelect: true,
		nextArrow: (
			<SampleNextArrow
				className={'relative'}
				style={{}}
				onClick={undefined}
			/>
		),
		prevArrow: (
			<SamplePrevArrow
				className={undefined}
				style={{}}
				onClick={undefined}
			/>
		),
	};

	return (
		<div className="w-[580px]">
			<Slider {...topSliderSettings}>
				{imgUrlAry &&
					imgUrlAry.map((link, index) => (
						<div
							className="border-solid border-l-[1px] border-t-[1px] border-r-[1px] border-b-[1px] border-[#e5e5e5]"
							key={index}
							onMouseOver={(e) => {
								//鼠标进入
								setIsImageDetail(true);
							}}
							onMouseMove={(e) => {
								//获取鼠标在div内的相对位置
								const rect =
									e.currentTarget.getBoundingClientRect();
								const x = e.clientX - rect.left;
								const y = e.clientY - rect.top;
								setMov({
									movementX: x,
									movementY: y,
								});
							}}
							onMouseLeave={() => {
								//鼠标离开
								setIsImageDetail(false);
								setMov({
									movementX: 0,
									movementY: 0,
								});
							}}
						>
							<div className="group w-full h-[340px] mx-auto overflow-hidden relative cursor-move">
								<Image
									className={`object-contain`}
									alt=""
									src={link}
									fill
                                    sizes="32vw, 32vw, 32vw"
									style={{
										opacity: `${isImageDetail ? 0 : 1}`,
										transition: `opacity 0.8s ease-in-out`,
									}}
								></Image>
								<Image
									className={`object-contain`}
									alt=""
									src={link}
									fill
                                    sizes="48vw, 48vw, 48vw"
									quality={100}
									style={{
										opacity: `${isImageDetail ? 1 : 0}`,
										transition: `opacity 0.2s ease-in-out`,
										transform: `translate(${
											mov.movementX === 0
												? 0
												: mov.movementX > 580 / 3
												? (580 * 2) / 3 - mov.movementX
												: 580 / 3
										}px,${
											mov.movementY === 0
												? 0
												: mov.movementY > 340 / 3
												? (340 * 2) / 3 - mov.movementY
												: 340 / 3
										}px) scale(${
											mov.movementX === 0 &&
											mov.movementY === 0
												? 1.5
												: 1.5
										})`,
										position: 'absolute',
										top: 0,
										left: 0,
									}}
								></Image>
							</div>
						</div>
					))}
			</Slider>
			<div className="w-[508px] mx-auto mt-[5pxp">
				<Slider {...bottomSliderSettings}>
					{imgUrlAry.map((link, index) => (
						<div className="" key={index}>
							<div
								className={`w-[81px] h-[66px] relative overflow-hidden border-solid border-[1px] ${
									index === selectedIndex
										? 'border-[#f8c400]'
										: 'border-[#e5e5e5]'
								}`}
							>
								<Image
									className="object-contain"
									alt=""
									src={link}
									fill
									quality={75}
                                    sizes="5vw, 5vw, 5vw"
								></Image>
							</div>
						</div>
					))}
				</Slider>
			</div>
		</div>
	);
};

export default ProductDetailCarousel;
